import React from 'react'
import AppRouter from './AppRouter'
import ChatBox from './Components/FloatingIcon/ChatFloat'

const AppLoader = () => {
  return (
    <>
        <ChatBox />
        <AppRouter />
    </>
  )
}

export default AppLoader